import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        customizedCity: [],
        searchCharts: [], // suggestion的排序显示规则
        isExactSearch: false,
        propertyConfigs: [],
        keywordType: '',
        keyword: '',
        searchData: [], // 中台
        showLocation: false, // 中台
        locationSuggestionUrl: '' // 中台
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
